// ACTIONS
export const FETCH_ONLINE_PROFILES = 'offerzen/onlineProfiles/FETCH_ONLINE_PROFILES'
export const FETCH_ONLINE_PROFILES_SUCCESS = 'offerzen/onlineProfiles/FETCH_ONLINE_PROFILES_SUCCESS'

export const UPDATE_ONLINE_PROFILES = 'offerzen/onlineProfiles/UPDATE_ONLINE_PROFILES'
export const UPDATE_ONLINE_PROFILES_SUCCESS = 'offerzen/onlineProfiles/UPDATE_ONLINE_PROFILES_SUCCESS'
export const UPDATE_ONLINE_PROFILES_ERROR = 'offerzen/onlineProfiles/UPDATE_ONLINE_PROFILES_ERROR'

export const TOGGLE_ONLINE_PROFILES = 'offerzen/onlineProfiles/TOGGLE_ONLINE_PROFILES'

// ACTION CREATORS
export const fetchOnlineProfiles = id => ({
  type: FETCH_ONLINE_PROFILES,
  payload: {
    loading: true,
    id,
  },
})

export const fetchOnlineProfilesSuccess = data => ({
  type: FETCH_ONLINE_PROFILES_SUCCESS,
  payload: {
    loading: false,
    data,
  },
})

export const updateOnlineProfiles = (data, id, resolve, reject) => ({
  type: UPDATE_ONLINE_PROFILES,
  meta: { resolve, reject },
  payload: {
    loading: true,
    data,
    id,
  },
})

export const updateOnlineProfilesSuccess = data => ({
  type: UPDATE_ONLINE_PROFILES_SUCCESS,
  payload: {
    loading: false,
    data,
  },
})

export const updateOnlineProfilesError = errorMessage => ({
  type: UPDATE_ONLINE_PROFILES_ERROR,
  error: true,
  payload: new Error(errorMessage),
})

export const toggleOnlineProfiles = editing => ({
  type: TOGGLE_ONLINE_PROFILES,
  payload: { editing },
})

// REDUCERS
const initialState = {
  loading: false,
  github_url: null,
  linkedin_url: null,
  bitbucket_url: null,
  behance_url: null,
  dribble_url: null,
  blog_url: null,
  personal_site_url: null,
}

const onlineProfilesReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_ONLINE_PROFILES:
      return {
        ...state,
        loading: action.payload.loading,
      }

    case FETCH_ONLINE_PROFILES_SUCCESS:
    case UPDATE_ONLINE_PROFILES_SUCCESS:
      return {
        ...state,
        ...action.payload.data,
        loading: action.payload.loading,
      }

    case TOGGLE_ONLINE_PROFILES:
      return {
        ...state,
        editing: action.payload.editing,
      }

    case UPDATE_ONLINE_PROFILES_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      }

    default:
      return state
  }
}

export default onlineProfilesReducer

export const getOnlineProfiles = state => state.views.profile.onlineProfiles || initialState
